import { render, staticRenderFns } from "./h3-checkbox-item.vue?vue&type=template&id=65dba0b8&"
import script from "./h3-checkbox-item.vue?vue&type=script&lang=js&"
export * from "./h3-checkbox-item.vue?vue&type=script&lang=js&"
import style0 from "./h3-checkbox-item.vue?vue&type=style&index=0&id=65dba0b8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports